var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00001 6.25V8.50311C8.62656 8.50843 8.29278 8.52281 8.00417 8.5616C7.51253 8.62771 7.04126 8.77676 6.65902 9.15901C6.27677 9.54126 6.12771 10.0125 6.06161 10.5041C5.99993 10.9629 5.99996 11.5358 6 12.2006V15.2993C5.99996 15.9642 5.99993 16.5371 6.06161 16.9958C6.12771 17.4875 6.27677 17.9588 6.65902 18.341C7.04126 18.7232 7.51253 18.8723 8.00417 18.9384C8.4629 19.0001 9.03578 19.0001 9.70063 19H14.2994C14.9642 19.0001 15.5371 19.0001 15.9958 18.9384C16.4875 18.8723 16.9588 18.7232 17.341 18.341C17.7232 17.9588 17.8723 17.4875 17.9384 16.9958C18.0001 16.5371 18.0001 15.9642 18 15.2993V12.2006C18.0001 11.5358 18.0001 10.9629 17.9384 10.5041C17.8723 10.0125 17.7232 9.54126 17.341 9.15901C16.9588 8.77676 16.4875 8.62771 15.9958 8.56161C15.7072 8.52281 15.3734 8.50843 15 8.50311V6.25C15 5.00736 13.9927 4 12.75 4H11.25C10.0074 4 9.00001 5.00736 9.00001 6.25ZM11.25 5.5C10.8358 5.5 10.5 5.83579 10.5 6.25V8.5H13.5V6.25C13.5 5.83579 13.1642 5.5 12.75 5.5H11.25ZM12 12.25C11.1715 12.25 10.5 12.9215 10.5 13.75C10.5 14.5784 11.1715 15.25 12 15.25C12.8284 15.25 13.5 14.5784 13.5 13.75C13.5 12.9215 12.8284 12.25 12 12.25Z",
    fill: "#3D3C7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.1b77bbd29c002e046e47b39d81c0998b.svg";
export { ForwardRef as ReactComponent };